// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2y3IR","tab":"Tabs_tab__3CUUz","tabActive":"Tabs_tabActive__3Tn73"};